import React from "react";
import styles from "./index.module.scss";

interface AsideBlockProps {
    title: string;
    count?: number;
    children: React.ReactNode;
    extra?: React.ReactNode;
}

export default function AsideBlock({
    title,
    count,
    extra,
    children
}: AsideBlockProps) {
    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <h1 className={styles.title}>
                    {title}
                    {count !== undefined && (
                        <span className={styles.count}>({count})</span>
                    )}
                </h1>

                <div className={styles.extra}>{extra}</div>
            </div>

            <div className={styles.body}>{children}</div>
        </div>
    );
}
